import { useQuery, useMutation } from '@tanstack/react-query';
import { upgradeService } from '@/services/upgradeService';

export function useUpgradeData(token: string) {
  return useQuery({
    queryKey: ['upgrade', token],
    queryFn: () => upgradeService.getUpgradeData(token),
    enabled: !!token,
    retry: false, // Don't retry on invalid token
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useCreateCheckout(token: string) {
  return useMutation({
    mutationFn: ({ planSlug, billingCycle }: { planSlug: string; billingCycle: 'monthly' | 'yearly' }) =>
      upgradeService.createCheckout(token, planSlug, billingCycle),
    onSuccess: (data) => {
      // Redirect to Stripe Checkout
      window.location.href = data.checkoutUrl;
    },
  });
}
